import React from "react";
import { Row, Col } from "react-bootstrap";
import bgImage from "../../images/loginBackgrounds/unsplash.png";
import bgBottom from "../../images/loginBackgrounds/bottom-mtn.png";
import mtnLogo from "../../images/DEQ_Logos/Mountain-Logo-Utah-DW-2.svg";
import portalArrow from "../../images/buttons/portal-arrow.svg";
import { Link } from "react-router-dom";
import WaterSystemSearchInput from "../reuseableComponents/WaterSystemSearchInput";
import "./HomePage.css";

const HomePage = ({ selectedWaterSystem, setSelectedWaterSystem }) => (
  <>
    <Row>
      <Col>
        <div id="landingPageContainer" className="landing-page-container">
          <div
            className="landing-bg"
            style={{ backgroundImage: `url(${bgImage})` }}
          >
            <div className="landing-header">
              <div className="logo-container">
                <img src={mtnLogo} alt="Mountain Logo" className="mtn-logo" />
              </div>
              <p className="landing-title">Welcome to Waterlink</p>
              <div className="search-container">
                <WaterSystemSearchInput
                  page="home"
                  selectedWaterSystem={selectedWaterSystem}
                  setSelectedWaterSystem={setSelectedWaterSystem}
                />
              </div>
            </div>
            <div
              className="landing-bottom"
              style={{ backgroundImage: `url(${bgBottom})` }}
            >
              <div className="landing-bottom-content">
                <p className="landing-bottom-title">
                  Drinking Water for a healthy and prosperous Utah
                </p>
                <br />
                <p className="landing-bottom-desc">
                  WaterLink's mission is to provide accessible and transparent
                  information about Utah's public water systems, ensuring the
                  safety, quality, and regulatory compliance of drinking water.
                </p>
                <br />
                <div className="responsive-portal-btn-container">
                  <Link to="/public/request-portal-access">
                    <div className="responsive-portal-btn">
                      <div className="response-portal-txt">
                        <div className="portal-btn-title">
                          REQUEST PORTAL ACCESS&nbsp;&nbsp;
                          <img
                            src={portalArrow}
                            alt="Portal Access"
                            style={{ verticalAlign: "middle" }}
                          />
                        </div>
                        <div className="portal-btn-desc">
                          Create your portal account here for additional features
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  </>
);

export default React.memo(HomePage);
